export const chartColors = [
  '#6791ea',
  '#ca7254',
  '#61a0a8',
  '#91c7ae',
  '#749f83',
  '#e59625',
  '#bda29a',
  '#6e7074',
  '#546570',
  '#84ec0e',
  '#965c5c',
  '#3d6036',
  '#736839',
  '#6a3973',
  '#854225',
  '#365694',
  '#943939',
  '#25665e',
  '#8d9637',
  '#583796',
  '#845EC2',
  '#2db74f',
  '#CE4760',
  '#33202A',
  '#000000',
  '#1D2F6F',
  '#553E4E',
  '#69140E',
  '#21256E',
  '#1E9999',
  '#A23E2A',
  '#044B77',
  '#04A777',
  '#78c60e',
  '#A71D31',
  '#04724D',
  '#2C497F',
  '#ef5771',
  '#735751',
  '#51291E',
  '#4E6E58',
  '#00798C',
  '#232E21',
  '#c23531',
];

export const chartColorsDark = [
  '#6791ea',
  '#ca7254',
  '#61a0a8',
  '#0EE9A7',
  '#749f83',
  '#e59625',
  '#ff4c14',
  '#EBF378',
  '#c412e7',
  '#84ec0e',
  '#965c5c',
  '#3d6036',
  '#736839',
  '#6a3973',
  '#854225',
  '#365694',
  '#943939',
  '#25665e',
  '#8d9637',
  '#583796',
  '#845EC2',
  '#2db74f',
  '#CE4760',
  '#fb0283',
  '#cbbf14',
  '#006bff',
  '#f129b9',
  '#ec4a40',
  '#19b6e2',
  '#1E9999',
  '#A23E2A',
  '#044B77',
  '#04A777',
  '#78c60e',
  '#A71D31',
  '#04724D',
  '#2C497F',
  '#C6F300',
  '#735751',
  '#ff8400',
  '#4E6E58',
  '#00798C',
  '#73DB63',
  '#c23531',
];

function getThemePalette() {
  const isDarkMode = document.body.dataset?.theme === 'dark';
  return isDarkMode ? chartColorsDark : chartColors;
}

/**
* Itera sobre a lista de cores ciclicamente até atingir o número de variáveis
* definida por colorsAmount e retorna a lista acumulada de cores. Lógica semelhante
* à lógica do echarts para reutilização da lista de cores. A lista de cores para a
* configuração do gráfico deve ser a lista chartColors.
* @Param {Number} colorsAmount número de cores a serem geradas
*/
export function getColorsListByLength(colorsAmount, colorsList = null) {
  const currentColors = colorsList || getThemePalette();
  const colorsLength = currentColors.length;
  const cyclicColorsListByAmount = [];
  for (let index = 0; index < colorsAmount; index += 1) {
    cyclicColorsListByAmount.push(
      currentColors[((index % colorsLength) + colorsLength) % colorsLength],
    );
  }
  return cyclicColorsListByAmount;
}

